/**
 * Whether the viewer OWNS the app they are looking at.
 *
 * <p>A shared app carries no `workspaceId` — it lives in no Space of the viewer's — and that absence IS
 * the ownership signal. Both native surfaces reach the same fact from the other side: an owned app is
 * listed under a Space, a shared one arrives through the shared list with no Space at all.
 *
 * <p><b>Share and Delete have the SAME precondition, and it is this one.</b> A control that can only
 * fail is worse than no control.
 *
 * <p>It is not an authorization check and must never be used as one: the server owns that, by scoping
 * every read to the caller's own tenant. This decides what to OFFER.
 */
export function ownsApp(workspaceId: string | undefined | null): boolean {
  return typeof workspaceId === 'string' && workspaceId.trim().length > 0;
}
